<!-- 该弹窗组件用于用户中心页面中的各种弹窗需求 -->
<template>
  <transition name="slide-fade" @enter="beforeEnter" @leave="leave">
    <div class="dialog-wrap" v-if="visible" @click.self="clickModel">
      <div class="dialog-box" :style="{ width: width }">
        <p class="clearfix">
          <i class="right iconfont icon-c" @click="hide"></i>
        </p>
        <p class="title">
          <span class="inline">{{ title }}</span>
        </p>
        <div class="content">
          <!-- 根据不同的弹窗传入不同的内容 -->
          <slot></slot>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'user-dialog',
  props: {
    // 是否显示-必传
    visible: {
      type: Boolean,
      default: false
    },
    // 标题-必传
    title: {
      type: String,
      required: true
    },
    // 点击背景是否能关闭弹窗
    modal: {
      type: Boolean,
      default: false
    },
    // 内容盒子宽度
    width: {
      type: String,
      default: '650px'
    }
  },
  // mounted () {
  //   console.log(1, this)
  // },
  methods: {
    beforeEnter () {
      // v-modal等class都是饿了么组件弹窗背景的
      // 该函数和leave函数是给弹窗添加一个有过渡效果的弹窗
      let modal = document.createElement('div')
      modal.classList.add('v-modal', 'v-modal-enter')
      modal.style.zIndex = '1000'
      document.body.appendChild(modal)
      setTimeout(function () {
        modal.classList.remove('v-modal-enter')
      }, 200)
    },
    leave () {
      let modal = document.getElementsByClassName('v-modal')
      modal[0].classList.add('v-modal-leave')
      setTimeout(function () {
        document.body.removeChild(modal[0])
      }, 200)
    },
    hide () {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
    clickModel () {
      if (this.modal) {
        this.hide()
      }
    }
  }
}
</script>

<style lang="less" scoped>
.dialog-wrap {
  position: fixed; left: 0; right: 0; top: 0; bottom: 0; z-index: 1001;
  .dialog-box {
    position: relative; left: 0; top: 15%; margin: 0 auto; background-color: #ffffff; padding: 20px; border-radius: 3px;
    i.icon-c {
      cursor: pointer; color: #999;
      &:hover {
        color: #333333;
      }
    }
    p.title {
      border-bottom: 2px solid #dddddd; line-height: 40px; color: #343434;
      span {
        width: 120px; text-align: center; position: relative;
        &::before {
          content: ''; background-color: #ee3b37; width: 120px; height: 2px; position: absolute; bottom: -2px; left: 0;
        }
      }
    }
  }
}
</style>
